import React from "react";
import { PrimaryButton } from "@fluentui/react";
import { useTheme } from "../../../theme/OAS365Theme";

const CheckInNewFooterActions = ({
  backButtonVisibility,
  cancelButtonVisibility,
  nextButtonVisibility,
  checkinButtonVisibility,
  styleTheme,
  displayText,
  isButtonDisabled,
  onBack,
  onCancel,
  onMoveNext,
  onCheckin,
}) => {
  const theme = useTheme();
  const buttonTextStyles = {
    fontFamily: theme.fonts?.regular,
    fontSize: `${theme.fontSizes?.normal ?? 12}px`,
  };

  return (
    <>
      {backButtonVisibility && (
        <div styles={{ marginRight: "10px" }}>
          <PrimaryButton
            styles={{ root: { marginRight: "10px", ...buttonTextStyles } }}
            style={styleTheme.CancelButtonFillStyle}
            id="btnback"
            text={displayText.back}
            onClick={onBack}
          />
        </div>
      )}
      {cancelButtonVisibility && (
        <div styles={{ marginRight: "10px" }}>
          <PrimaryButton
            styles={{ root: { marginRight: "10px", ...buttonTextStyles } }}
            style={styleTheme.CancelButtonFillStyle}
            id="btncancel"
            text={displayText.cancel}
            onClick={onCancel}
          />
        </div>
      )}
      {nextButtonVisibility && (
        <PrimaryButton
          style={
            isButtonDisabled(displayText.next)
              ? styleTheme.DisableButtoneStyle
              : styleTheme.PrimaryButtonFillStyle
          }
          text={displayText.next}
          disabled={isButtonDisabled(displayText.next)}
          onClick={onMoveNext}
        />
      )}
      {checkinButtonVisibility && (
        <PrimaryButton
          style={
            isButtonDisabled(displayText.checkin)
              ? styleTheme.DisableButtoneStyle
              : styleTheme.PrimaryButtonFillStyle
          }
          text={displayText.checkin}
          disabled={isButtonDisabled(displayText.checkin)}
          onClick={onCheckin}
        />
      )}
    </>
  );
};

export default CheckInNewFooterActions;
